// convert text to whatsapp text
module.exports.whatsappLink = function (notifyObj) {
    // must have values 
    if(!notifyObj) return
    if(!notifyObj.sellerPhone) return
    if(!notifyObj.sellerPhoneCode) return
    // strip out the plus sign from phoneCode
    let areaCode = ""
    if(notifyObj.sellerPhoneCode){
        let initAreaCode = notifyObj.sellerPhoneCode.slice(0, 1)
        if(initAreaCode == "+"){
            areaCode = notifyObj.sellerPhoneCode.slice(1, notifyObj.sellerPhoneCode.length)
        } else {
            areaCode = notifyObj.sellerPhoneCode
        }
    }
    // combine the seller phone code and number
    let sellerPhoneNumber = `${areaCode}${notifyObj.sellerPhone}`
    // combine the buyer phone code and number
    let buyerPhoneNumber = notifyObj.buyerPhone ? `${notifyObj.buyerPhoneCode}${notifyObj.buyerPhone}` : false
    // item link
    let itemUrl = process.env.VUE_APP_CLT_URL + "/market/listItem/" + notifyObj.itemId
    // prepare the message note
    let message = `_Hi ${notifyObj.sellerShopName} @${notifyObj.sellerHandle}_`
    message += `\n\n_I'm ${notifyObj.buyerShopName} @${notifyObj.buyerHandle}. _`
    message += `\n_I found your shop on aNewItem. _`
    message += `\n_Can I buy your item *${notifyObj.itemTitle}* `
    message += `for ${notifyObj.itemCurrency.toUpperCase()} ${notifyObj.buyerPrice.toLocaleString()} ?_`
    buyerPhoneNumber ? message += `\n_You can reach me via ${buyerPhoneNumber}_` : ""
    message += `\n\n_See item: ${itemUrl}_`
    // encode the message for url
    let readyMessage = encodeURIComponent(message)
    // ready whatsapp link
    let link = `https://api.whatsapp.com/send?phone=${sellerPhoneNumber}&text=${readyMessage}`
    return link
}

// copy texts to clipboard
module.exports.copyTextFxn = function (wordToCopy) {
    if(!wordToCopy) return
    
    let textToCopy = wordToCopy;
    
    let myTemporaryInputElement = document.createElement("input");
    myTemporaryInputElement.type = "text";
    myTemporaryInputElement.value = textToCopy;
    
    document.body.appendChild(myTemporaryInputElement);
    
    myTemporaryInputElement.select();
    document.execCommand("Copy");
    
    document.body.removeChild(myTemporaryInputElement);
}

// share item on mobile devices native share functions
module.exports.shareItem = function (shareObj) {
    if(!shareObj) return
    
    // trigger device native share function
    if (navigator.share) {
        navigator.share(shareObj)
        .then(() => {
            // console.log('Thanks for sharing!');
            return true
        })
        .catch(err => { });
    } else {
        // console.log('Web share not supported! Works fine on mobile devices.');
        return false
    }
}

// search through any array of objects on pages
module.exports.fuzzySearch = function (Fuse, list, options, word) {
    let fuse = new Fuse(list, options);
    // find matching results
    let resultsArr = fuse.search(word)

    // insert the matching results full object
    let resultDetailsArr = []
    if(resultsArr.length){
        for(let x=0; x < resultsArr.length; x++){
            resultDetailsArr.push(resultsArr[x].item)
        }
        // display results found
        return resultDetailsArr
    }
}

// capitalize the first letter of a word
module.exports.capitalizeWord = function (val) {
    if(!val) return

	val = val.toString()
	var wordsInVal = val.split(" ")
	var finalWordArr = []
	for(var x = 0; x < wordsInVal.length; x++){
		var wordInitial = wordsInVal[x].slice(0, 1);
		var wordBalance = wordsInVal[x].slice(1, wordsInVal[x].length);
		finalWordArr.push(wordInitial.toUpperCase() + wordBalance)
	}

	return finalWordArr.join(" ")
}

// update to webpage title
module.exports.webpageTitle = (title) => {
    if(!title) return ''
    document.title = `${title} | aNewItem ...giving international items a new home 🛍 🛒 😍`
}

// append host url to photos path
module.exports.appendImgHostUrl = (path) => {
    if(!path) return ''
    let fullPath = process.env.VUE_APP_IMG_URL + path
    return fullPath
}

module.exports.toggleFooterPosition = (addRemoveClass, className) => {
    const el = document.getElementById("footer"); // select footer element
    if(el !== null){
        if (addRemoveClass === 'addClass') {
            el.classList.add(className);
        } else {
            el.classList.remove(className);
        }
    }
}

// check if two users are related - following, follower
module.exports.confirmUsersRelationship = (myRelationshipArr, confirmUserId) => {
    const userFound = myRelationshipArr.findIndex(user => user.id === confirmUserId)
    if(userFound === -1) return false // yes we are related
    return true // no we are not related
}

// count the number of records, used for showing x of x.length total
module.exports.paginateRecords = (theArray, theStep) => {
    if(theArray.length){
        const intervalArr = []
        if(theArray.length > theStep){
            for(let x=1; x < theArray.length; x++){
                x += theStep
                if(x > theArray.length){ x = theArray.length }
                intervalArr.push(x)
            }
        } else {
            intervalArr.push(theArray.length)
        }
        const resultObj = {
            total: theArray.length,
            steps: intervalArr
        }
        return resultObj
    }
    return {}
}

// determine to show save item or unsave item for later btn
module.exports.itemSavedCheckerFxn = (theItemId) => {
    if(!theItemId) return
    let localStorageSFLItemIds = JSON.parse(localStorage.getItem('ani_items_sfl')) 
    if(localStorageSFLItemIds && localStorageSFLItemIds.includes(theItemId) === true){
        return true
    }
    return false
}